import { QueryKey } from "@tanstack/react-query";
import { ServicePath } from "../../constants/apiConstants";
import { useFetchQuery } from "../core/rest/useFetchQuery";
import { UserGroup } from "./user.types";

type UserGroupsQueryResult = {
  groups: UserGroup[];
};

export function useGetUserGroups(entityUuid: string | undefined) {
  const queryKey: QueryKey = ["userGroups", entityUuid];
  const url = `${ServicePath.AccessGroupV1}/entities/${entityUuid}/groups`;
  return useFetchQuery<UserGroupsQueryResult>({
    queryKey,
    url,
    options: { enabled: !!entityUuid },
    skipAuthHeaders: true,
  });
}
